module.exports = __webpack_public_path__ + "static/img/yiduona.60f52bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/yiduona.png
// module id = Krws
// module chunks = 1